// extracted by mini-css-extract-plugin
export default {"cart-empty":"CartEmpty_cart-empty__06eEW","icon":"CartEmpty_icon__jqp7b","bg-logo":"CartEmpty_bg-logo__G7KCl","return-link":"CartEmpty_return-link__HseYH"};